import React, { useState } from 'react';

function BinarySearchControls({ onStart }) {
  const [inputArray, setInputArray] = useState('');
  const [searchElement, setSearchElement] = useState('');

  const handleStart = () => {
    const array = inputArray.split(',').map(Number);
    const element = parseInt(searchElement, 10);
    onStart(array, element);
  };

  const handlePredefinedData = () => {
    const predefinedArray = [2, 5, 6, 13, 17, 20, 21, 22];
    const predefinedElement = 21;
    onStart(predefinedArray, predefinedElement);
  };

  return (
    <div className="controls">
      <h2>Binary Search Visualizer</h2>
      <div>
        <label>
          Array (comma separated):
          <input
            type="text"
            value={inputArray}
            onChange={(e) => setInputArray(e.target.value)}
          />
        </label>
      </div>
      <div>
        <label>
          Element to find:
          <input
            type="text"
            value={searchElement}
            onChange={(e) => setSearchElement(e.target.value)}
          />
        </label>
      </div>
      <button onClick={handleStart}>Start Search</button>
      <button onClick={handlePredefinedData}>Use Predefined Data</button>
    </div>
  );
}

export default BinarySearchControls;
